import React from 'react';

import Default from '@common/embedded/text/Default';

const components = [
  {
    component: Default,
    key: 'Default'
  }
];

const ButtonBlock = ({ data }) => {
  const { style } = data;
  const Component = components.find(x => x.key === style)?.component || Default;
  return <Component data={data}/>;
}

export default ButtonBlock
